export default __webpack_public_path__ + "static/heroSectionImg-f0096a3697cb0193514a170df7b668df.webp";